// Convierte un pedido del catálogo en una venta precargada para Vender:
// qué prendas van al carrito, por qué canal y si vino por anuncio.

// El origen del pedido (?o=) → canal de la venta. El catálogo es una página
// web, así que lo que no se sabe de qué red vino queda como "Página web".
export function canalDeOrigen(origen) {
  if (origen === 'whatsapp') return 'WhatsApp';
  if (origen === 'instagram' || origen === 'bio' || origen === 'historia') return 'Instagram';
  if (origen === 'facebook') return 'Facebook';
  return 'Página web';
}

export const vinoPorAnuncio = (origen) => origen === 'anuncio';

// Prendas del pedido que se pueden vender ahora (existen y tienen stock).
// `faltan`: las que no se pudieron cargar, para avisar.
export function itemsDePedido(pedido, productos) {
  const items = []; const faltan = [];
  (pedido?.prendas || [pedido]).forEach((x) => {
    const prod = productos.find((p) => p.id === x.producto_id);
    if (!prod) { faltan.push(`${x.nombre_producto} (ya no está en el inventario)`); return; }
    const stock = Number(prod.stock || 0);
    if (stock <= 0) { faltan.push(`${x.nombre_producto} (sin stock)`); return; }
    const cantidad = Math.min(Number(x.cantidad || 1), stock);
    if (cantidad < Number(x.cantidad || 1)) faltan.push(`${x.nombre_producto} (solo hay ${stock})`);
    items.push({ producto: prod, cantidad });
  });
  return { items, faltan };
}

// Busca a la clienta en Clientes por los últimos 8 dígitos del teléfono.
export function clienteDePedido(pedido, clientes) {
  const dig = (t) => (t || '').replace(/\D/g, '').slice(-8);
  const tel = dig(pedido?.cliente_telefono);
  if (!tel) return null;
  return clientes.find((c) => dig(c.telefono) === tel) || null;
}
